/* ============================================================
 * Fechas y formato de la app pública.
 *
 * Siempre texto 'YYYY-MM-DD' en horario local, que es lo que envía y espera
 * el backend. Pasar por Date y toISOString() las convierte a UTC y desplaza
 * el día: en Chile (UTC-4) el 14 de agosto se convierte en el 13.
 * ============================================================ */

export const DOW = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

export const localIso = (d) => {
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d - tz).toISOString().slice(0, 10);
};

export const isoOffset = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return localIso(d);
};

export const addDaysIso = (iso, n) => {
  const d = new Date(iso + 'T00:00:00');
  d.setDate(d.getDate() + n);
  return localIso(d);
};

export const clp = (n) => '$' + (n || 0).toLocaleString('es-CL');

/** "viernes, 14 de agosto" */
export const fechaLarga = (iso) => {
  const t = new Date(iso + 'T00:00:00')
    .toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
  return t.charAt(0).toUpperCase() + t.slice(1);
};

/** Normaliza el email (minúsculas, sin espacios) o devuelve null. Misma regla que el backend. */
export const normEmail = (entrada) => {
  const e = String(entrada ?? '').trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e) ? e : null;
};

/** Normaliza a E.164 chileno o devuelve null. Misma regla que el backend. */
export const normTel = (entrada) => {
  const d = String(entrada || '').replace(/\D/g, '');
  let n = null;
  if (d.length === 11 && d.startsWith('569')) n = '+' + d;
  else if (d.length === 9 && d.startsWith('9')) n = '+56' + d;
  else if (d.length === 8) n = '+569' + d;
  return n && /^\+569\d{8}$/.test(n) ? n : null;
};
